import {
  useOutlookStore,
  useResourceStore
} from "@/pages/taskpane/shared/stores";
import { useEffect, useRef } from "react";


export const useOfficeEvents = () => {
  const { selectedResource, setSelectedResource } = useResourceStore();
  const {
    requiredAttendees,
    optionalAttendees,
    enhancedLocation,
  } = useOutlookStore();

  const syncInProgress = useRef(false);

  // ✅ Cleanup
  useEffect(() => {
    return () => {
      syncInProgress.current = false;
    };
  }, []);

  return {
    // Status
    isInitialized: true,
    // Manual sync

    // Sync status for preventing conflicts
    isSyncInProgress: () => syncInProgress.current,

    // Data counts for debugging
    counts: {
      requiredAttendees: requiredAttendees.length,
      optionalAttendees: optionalAttendees.length,
      enhancedLocation: enhancedLocation.length,
      selectedResources: selectedResource.length,
    },
  };
};
